import ImageToolTip from "./ImageToolTip";
export default ImageToolTip;
